import HeroBannerSecondarySchema from 'sitemodel/schema/components/HeroBannerSecondarySchema'
import schemaToReactType from 'sitemodel/schema/util/schemaToReactType'
import schemaToTypeGuard from 'sitemodel/schema/util/schemaToTypeGuard'

export type HeroBannerSecondaryContainerProps = schemaToReactType<
  typeof HeroBannerSecondarySchema
>

export const HeroBannerSecondaryContainerTypeGuard = schemaToTypeGuard(
  HeroBannerSecondarySchema
)
